module.exports = __webpack_public_path__ + "static/media/4.eef96079.png";